import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {PageSettingsSchema} from './pageSettings'

export function buildPageSchemaForTemplate<Template extends z.ZodType>(templateSchema: Template) {
  return buildEntrySchemaFor('containerPage', {
    fields: z.lazy(() =>
      z.object({
        path: z.string(),
        settings: safeOptional(PageSettingsSchema),
        template: templateSchema,
        title: z.string(),
      }),
    ),
  })
}
